import { getFeatureFlagValue } from '@citrite/feature-flags';
import { ProjectUserRole } from '@sharefiledev/projects-pilet-sdk';
import { FeatureFlag } from './featureFlags';
import { t } from './translate';

export const ShareFileProjectTemplateSolution = () => {
	return {
		template: { name: 'Enhanced project experience', value: 'workmgmttemplate' },
		tag: { name: 'system:project:template', value: 'enhanced_project' },
		resourceType: 'sharefile:project',
		eventUrn: 'urn:drawer:template-pilet:open-template-drawer',
		footerButtonLabels: {
			buttonText: {
				en: t('AddOrUpdateProject.create'),
				es: t('AddOrUpdateProject.create'),
				de: t('AddOrUpdateProject.create'),
				fr: t('AddOrUpdateProject.create'),
				it: t('AddOrUpdateProject.create'),
				ja: t('AddOrUpdateProject.create'),
				nl: t('AddOrUpdateProject.create'),
				'pt-BR': t('AddOrUpdateProject.create'),
			},
			cancelButtonText: {
				en: t('AddOrUpdateProject.cancel'),
				es: t('AddOrUpdateProject.cancel'),
				de: t('AddOrUpdateProject.cancel'),
				fr: t('AddOrUpdateProject.cancel'),
				it: t('AddOrUpdateProject.cancel'),
				ja: t('AddOrUpdateProject.cancel'),
				nl: t('AddOrUpdateProject.cancel'),
				'pt-BR': t('AddOrUpdateProject.cancel'),
			},
		},
		customErrorMessage: {
			en: t('AddOrUpdateProject.templateRunFailed'),
			es: t('AddOrUpdateProject.templateRunFailed'),
			de: t('AddOrUpdateProject.templateRunFailed'),
			fr: t('AddOrUpdateProject.templateRunFailed'),
			it: t('AddOrUpdateProject.templateRunFailed'),
			ja: t('AddOrUpdateProject.templateRunFailed'),
			nl: t('AddOrUpdateProject.templateRunFailed'),
			'pt-BR': t('AddOrUpdateProject.templateRunFailed'),
		},
	};
};

export const shouldDisableLegacyRoles = () =>
	getFeatureFlagValue(FeatureFlag.DisableLegacyRoles) ?? false;

export const mockUserRole = shouldDisableLegacyRoles()
	? ProjectUserRole.Guest
	: ProjectUserRole.Owner;
